<template>
    <div>
        <p>
            <strong>Nos termos e para os efeitos dos artigos 1341 e 1342 do Código Civil italiano</strong>, o Utilizador declara expressamente ter
            lido, compreendido e aceite as seguintes cláusulas:
        </p>
        <p>Art. 1 Definições, al. l), “Fleequid”, entidade jurídica e regime fiscal aplicável;</p>
        <p>Art. 2.3 Comissões devidas tanto pelo Vendedor como pelo Comprador;</p>
        <p>Art. 2.4 Modalidades de leilão e determinação do preço de adjudicação;</p>
        <p>Art. 2.5 Processo de revenda;</p>
        <p>
            Art. 3 Aprovação de eventuais condições gerais propostas pelos utilizadores, modificação unilateral das Condições Gerais por parte da
            Fleequid e hierarquia dos textos contratuais
        </p>
        <p>Art. 4.5 Limitações à utilização do Marketplace;</p>
        <p>Art. 4.6 Medidas adotadas pela Fleequid em caso de violação das regras de utilização;</p>
        <p>Art. 4.7 Resolução;</p>
        <p>Art. 4.8 Penalidade;</p>
        <p>Art. 4.10 Exclusão de responsabilidade pelo funcionamento do Marketplace;</p>
        <p>Art. 4.11 Cancelamento do perfil do Utilizador e exercício do direito de resolução;</p>
        <p>
            Art. 6 relativo a: cláusula resolutiva expressa, exclusividade de venda, condições e duração dessa exclusividade, possibilidade de
            adjudicação subsequente, limitações à venda, possibilidade de anulação ou resolução da venda em caso de atraso ou falta de pagamento do
            Comprador, renúncia do Vendedor a exceções ou pretensões, cláusula de indemnização, dossier técnico, penalidades a cargo do Vendedor;
        </p>
        <p>
            Art. 7 Convite à contratação (invitatio ad offerendum), duração da oferta irrevogável de compra, condições particulares de leilão, preço
            de reserva;
        </p>
        <p>Art. 8.4 Tratamento do depósito caução;</p>
        <p>Art. 9.3 Pagamento do preço do veículo;</p>
        <p>
            Art. 9.4 Faturação antecipada a pedido da Fleequid, condição suspensiva do pagamento subordinada ao recebimento integral por parte do
            Comprador (pay-when-paid), obrigação de emissão de nota de crédito em caso de falta de pagamento ou anulação da venda, faculdade de
            compensação, penalidades diárias por atrasos ou omissões e renúncia do Vendedor a exceções ou pretensões contra a Fleequid;
        </p>
        <p>Art. 9.5 Penalidade;</p>
        <p>Arts. 9.7 e 9.8 Prazo para denúncia de vícios e defeitos;</p>
        <p>Art. 9.10 Cláusula resolutiva expressa e penalidade;</p>
        <p>
            Art. 10 Condições de pagamento, resolução, penalidades, condições que regulam a revenda e exclusão de responsabilidade, quilometragem,
            prazos de verificação de defeitos no momento da entrega;
        </p>
        <p>
            Art. 11 Exclusão de garantia e exclusão de responsabilidade da Fleequid, transferência do risco, cláusula resolutiva expressa,
            penalidades, direito de anulação da venda, exclusão de vícios ocultos, limites de responsabilidade baseados na quilometragem e idade do
            veículo;
        </p>
        <p>
            Art. 13 Reclamações, propostas de resolução da reclamação, resolução da reclamação pela Fleequid mediante anulação da venda, vícios
            ocultos, exclusão de responsabilidade, cláusula “visto e aceite”, penalidades;
        </p>
        <p>Art. 14 Cláusula de conexão;</p>
        <p>Art. 15 Lei aplicável, língua e foro competente.</p>
    </div>
</template>
